<template>
  <PortfolioFormLayout :loading="loading">
    <template #header>
      <h5 class="my-2">{{ isUpdateForm ? 'Update' : 'Create' }} Feature</h5>
    </template>
    <template #body>
      <FeatureFromPresentational
        v-model:description="description"
        v-model:name="name"
        :error-messages="errorMessages"
        :loading="loading"
        :server-error="serverError"
        @submit="submit"
      />
    </template>
  </PortfolioFormLayout>
</template>

<script lang="ts" setup>
import {Detail} from '@/api/errorMessage';
import {FeatureCreateUpdate} from '@/stores/userManagement/userManagement';

const props = defineProps<{
  isUpdateForm: boolean;
  id?: number;
}>();

const router = useRouter();

// Stores
const featuresStore = useFeaturesStore();
const getFeatures = computed(() => featuresStore.getFeatures);

const loading = ref(false);

// Form data
const name = ref('');
const description = ref('');
const errorMessages = ref(new Map());
const serverError = ref(false);

const submit = async (form: globalThis.Ref<HTMLFormElement | null>) => {
  loading.value = true;
  try {
    const feature: FeatureCreateUpdate = {
      name: name.value,
      description: description.value,
    };
    if (!props.isUpdateForm) {
      await featuresStore.createFeature(feature);
      router.go(-1);
    } else {
      const updateFeature: FeatureCreateUpdate = {
        ...feature,
        id: props.id,
      };
      await featuresStore.updateFeature(updateFeature);
      router.go(-1);
    }
  } catch (errorMessage: any) {
    serverError.value = true;
    errorMessages.value = new Map();
    // Remove .was-validated for server-side validation response.
    form.value?.classList.remove('was-validated');
    if (typeof errorMessage !== 'string' && errorMessage.length > 0) {
      errorMessage.forEach((d: Detail) => errorMessages.value.set(d.loc[1], d.msg));
    }
    form.value?.classList.remove('was-validated');
    console.log(errorMessage);
  } finally {
    loading.value = false;
  }
};

const load = async () => {
  if (props.isUpdateForm === true) {
    // Try find the item in store state
    let item = getFeatures.value.find((i) => i.id === props.id);
    // If the item is missing, try to fetch it
    if (item === undefined && props.id !== undefined) {
      try {
        const data = await featuresStore.readFeatureById(props.id);
        item = data;
      } catch (error) {
        console.log(error);
      }
    }
    if (item !== undefined) {
      // Set the form data
      name.value = item.name;
      description.value = item.description;
    }
  }
};

onMounted(() => load());
</script>
